module.exports = __webpack_public_path__ + "img/cashier.0d94c9a6.svg";